import { Link } from 'react-router-dom';

const FullFooter = ({ onSubscribe }) => (
  <footer data-testid="footer">
    <div className="footer-top">
      <div>
        <div className="footer-brand-row">
          <img src="/nc-logo-white.jpg" alt="Nile Capital" className="footer-logo" />
          <div className="footer-brand-name">Nile Capital</div>
        </div>
        <p className="footer-desc">Weekly treasury company analysis, macro insights, and market lessons.</p>
        <div className="footer-social">
          <a href="https://x.com/nilecapitalco" target="_blank" rel="noopener noreferrer" data-testid="social-x" aria-label="X (Twitter)">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.736-8.857L1.254 2.25H8.08l4.253 5.622L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z"/></svg>
          </a>
          <a href="https://www.linkedin.com/company/nilecapitalco/" target="_blank" rel="noopener noreferrer" data-testid="social-linkedin" aria-label="LinkedIn">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
          </a>
        </div>
      </div>
      <div className="footer-col">
        <h4>Company</h4>
        <Link to="/about" data-testid="footer-about">About</Link>
        <a href="mailto:support@nilecapital.co" data-testid="footer-contact">Contact</a>
        <Link to="/pricing" data-testid="footer-pricing">Pricing</Link>
      </div>
      <div className="footer-col">
        <h4>Read</h4>
        <Link to="/articles" data-testid="footer-articles">Articles</Link>
        <Link to="/newsletter" data-testid="footer-letter">NC Weekly Letter</Link>
      </div>
      <div className="footer-col">
        <h4>Subscribe</h4>
        <button onClick={onSubscribe} className="footer-subscribe-btn" data-testid="footer-subscribe">Get the newsletter</button>
      </div>
    </div>
    <div className="footer-bottom">&copy; 2015-2026 Nile Capital Aus Pty Ltd. All rights reserved.</div>
  </footer>
);

const SimpleFooter = () => (
  <div className="footer-simple" data-testid="footer-simple">
    &copy; 2015-2026 Nile Capital Aus Pty Ltd. All rights reserved.
  </div>
);

export { FullFooter, SimpleFooter };
